/**
 * @desc 贴标管理交货单列表查询
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierDeliveryOrder.supplierDeliveryOrderPageList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierDeliveryOrder/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
